module.exports = __webpack_public_path__ + "media/home-video-md.095273eb.mp4";